import React from "react";
import { Box as MuiBox, Typography, Tooltip, Chip } from "@mui/material";

function GridFilterSummary ({ isFiltered, selectedFilters, headerMap, setSelectedFilters }) {
  if (!isFiltered) return null;

  return (
    <MuiBox
      sx={{
        width: "100%",
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "8px 12px",
        margin: "6px 0 10px 0",
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        alignItems: "center",
        background: "#f9fafb",
        boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05)",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, color: "#555", mr: 1, minWidth: "70px" }}>
        적용된 필터:
      </Typography>

      {Object.entries(selectedFilters).map(([field, values]) => {
        if (!values || values.length === 0) return null;
        const label = headerMap[field] || field;
        let displayText = values.length > 3
          ? `${label}: ${values.length}개`
          : `${label}: ${values.join(", ")}`;

        return (
          <Tooltip key={field} title={values.join(", ")} arrow>
            <Chip
              label={displayText}
              variant="outlined"
              size="small"
              color="primary"
              sx={{
                fontSize: "0.8rem",
                borderRadius: "6px",
                "& .MuiChip-deleteIcon": {
                  color: "#666",
                  "&:hover": { color: "#d32f2f" },
                },
              }}
              onDelete={() => {
                setSelectedFilters((prev) => ({ ...prev, [field]: [] }));
              }}
            />
          </Tooltip>
        );
      })}
    </MuiBox>
  );
};

export default GridFilterSummary;
